import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Typography,
  Divider,
  Box,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import {
  setClaimTimeHandler,
  finalizeHandler,
} from "../../ContractAction/LaunchPadAction";
import CustomDatePicker from "../../Components/DatePicker";
import { FairLaunchTheme } from "../../LaunchPad/CeateFairLaunch/FairLaunchTheme";
import { dayjs } from "dayjs";

const Finalize = ({ open, onClose, poolAddr, setUpdate, update }) => {
  const [claimTime, setClaimTime] = useState();
  const [error, setError] = useState("");
  const [enableFinalize, setEnableFinalize] = useState(true);
  const [loading, setLoading] = useState({
    claimNow: false,
    saveSetting: false,
    finalize: false,
  });
  console.log("claimTime", claimTime);

  const formatDateToLocalInput = (date) => {
    const pad = (n) => (n < 10 ? "0" + n : n);
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    );
  };

  const handleSetTime = async () => {
    if (!claimTime || new Date(claimTime) <= new Date()) {
      setError("Claim time needs to be after now.");
      return;
    }

    try {
      setLoading((prev) => ({ ...prev, saveSetting: true }));
      const tx = await setClaimTimeHandler(poolAddr, claimTime);
      if (tx) {
        setEnableFinalize(false);
        setError("");
      }
      setUpdate((prev) => !prev);
    } catch (e) {
      console.error("Error setting claim time:", e);
    } finally {
      setLoading((prev) => ({ ...prev, saveSetting: false }));
    }
  };

  const handleClaimNow = async () => {
    const now = Math.floor(Date.now() / 1000) + 10; // current time in seconds + 10

    try {
      console.log("formattedTime (unix timestamp)", now);
      setLoading((prev) => ({ ...prev, claimNow: true }));
      const tx = await setClaimTimeHandler(poolAddr, now); // pass as number or BigInt
      if (tx) {
        setClaimTime(now); // store as number
        setEnableFinalize(false);
        setError("");
      }
      setUpdate((prev) => !prev);
    } catch (e) {
      console.error("Error in Claim Now:", e);
    } finally {
      setLoading((prev) => ({ ...prev, claimNow: false }));
    }
  };

  const finalizeHandlerClick = async () => {
    try {
      setLoading((prev) => ({ ...prev, finalize: true }));
      const tx = await finalizeHandler(poolAddr);
      // Optional: handle success/failure state
      setUpdate((prev) => !prev);
    } catch (e) {
      console.error("Error finalizing:", e);
    } finally {
      setLoading((prev) => ({ ...prev, finalize: false }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: (theme) => ({
          ...FairLaunchTheme.cardStyle(theme),
          m: { xs: 2, sm: 3 },
        }),
      }}
    >
      <DialogTitle
        sx={(theme) => ({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...FairLaunchTheme.gradientText(theme),
          fontSize: { xs: "1.25rem", sm: "1.5rem" },
          pb: 2,
        })}
      >
        Finalize
        <IconButton onClick={onClose} sx={{ color: "inherit" }}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2 }}>
        <Box mb={3}>
          <Typography
            variant="subtitle1"
            sx={(theme) => ({
              fontWeight: "bold",
              ...FairLaunchTheme.gradientText(theme),
              fontSize: { xs: "1rem", sm: "1.1rem" },
            })}
          >
            1. Set time
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mt: 1,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            Claim time (UTC)
          </Typography>
          <CustomDatePicker
            label="Set Time"
            value={claimTime}
            onChange={(newValue) => setClaimTime(newValue)}
          />

          <Box display="flex" gap={1} mt={2}>
            <Button
              variant="outlined"
              onClick={handleSetTime}
              disabled={loading.saveSetting}
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              {loading.saveSetting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Save Setting"
              )}
            </Button>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box mt={3}>
          <Typography
            variant="subtitle1"
            sx={(theme) => ({
              fontWeight: "bold",
              ...FairLaunchTheme.gradientText(theme),
              fontSize: { xs: "1rem", sm: "1.1rem" },
            })}
          >
            2. Finalize
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mt: 1,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            Click the button below to finalize the pool.
          </Typography>

          <Button
            variant="contained"
            disabled={enableFinalize || loading.finalize}
            onClick={finalizeHandlerClick}
            sx={(theme) => ({
              ...FairLaunchTheme.neonButton(theme),
              mt: 2,
              width: "100%",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "10px 16px", sm: "12px 24px" },
              "&.Mui-disabled": {
                backgroundColor: "#9e9e9e",
                color: "#ffffff",
                opacity: 0.6,
              },
            })}
          >
            {loading.finalize ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Finalize"
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Finalize;
